import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { ProtectedRoute } from "./ProtectedRoute.js";
import AppLayout from "./components/Layout/AppLayout";
import { PageLoader } from "./components/ui/States";

import Login from "./pages/Login.js";

const AdminDashboard = lazy(() => import("./pages/admin/dashboard/adminDashboard.jsx"));

const PrCurrencyType = lazy(() => import("./pages/admin/paymentReceipt/prCurrencyType.js"));
const PrEventType = lazy(() => import("./pages/admin/paymentReceipt/prEventType.js"));
const PrOccupancyType = lazy(() => import("./pages/admin/paymentReceipt/prOccupancyType.js"));
const PrRegistrationType = lazy(() => import("./pages/admin/paymentReceipt/prRegistrationType.js"));
const PrPaymentType = lazy(() => import("./pages/admin/paymentReceipt/prPaymentType.js"));
const PrRegistrationCategory = lazy(() => import("./pages/admin/paymentReceipt/prRegistrationCategory.js"));
const PaymentReceiptReceived = lazy(() => import("./pages/admin/paymentReceipt/paymentReceiptReceived.js"));
const PaymentReceiptGenerated = lazy(() => import("./pages/admin/paymentReceipt/paymentReceiptGenerated.js"));
const PaymentReceiptPdf = lazy(() => import("./pages/admin/paymentReceipt/paymentReceiptPdf.jsx"));
const PrParticipantPaymentType = lazy(() => import("./pages/admin/paymentReceipt/prParticipantPaymentType.js"));

const InvoiceReceiptReceived = lazy(() => import("./pages/admin/invoiceReceipt/invoiceReceiptReceived.js"));
const InvoiceReceiptGenerated = lazy(() => import("./pages/admin/invoiceReceipt/invoiceReceiptGenerated.js"));
const InvoiceRegType = lazy(() => import("./pages/admin/invoiceReceipt/invoiceRegType.js"));
const InvoiceInBank = lazy(() => import("./pages/admin/invoiceReceipt/invoiceInBank.js"));
const InvoiceUsBank = lazy(() => import("./pages/admin/invoiceReceipt/invoiceUsBank.js"));
const InvoiceReceiptPdf = lazy(() => import("./pages/admin/invoiceReceipt/invoiceReceiptPdf.jsx"));

const AbCategory = lazy(() => import("./pages/admin/abstractReceipt/abCategory.js"));
const AbstractType = lazy(() => import("./pages/admin/abstractReceipt/abstractType.js"));

const InvitationCategory = lazy(() => import("./pages/admin/invitationLetter/invitationCategory.js"));
const AllInvitationLetter = lazy(() => import("./pages/admin/invitationLetter/allInvitationLetter.js"));
const CurrentInvitationLetter = lazy(() => import("./pages/admin/invitationLetter/currentInvitationLetter.js"));

const PendingProgramManager = lazy(() => import("./pages/admin/abstractReceipt/pendingProgramManager.js"));
const ApprovedProgramManager = lazy(() => import("./pages/admin/abstractReceipt/approvedProgramManager.js"));

const AllReviewers = lazy(() => import("./pages/admin/abstractReceipt/allReviewers.js"));
const ApprovedReviewers = lazy(() => import("./pages/admin/abstractReceipt/approvedReviewers.js"));
const PendingReviewers = lazy(() => import("./pages/admin/abstractReceipt/pendingReviewers.js"));

const ApprovedBlogs = lazy(() => import("./pages/admin/blogs/approvedBlogs.js"));
const PendingBlogs = lazy(() => import("./pages/admin/blogs/pendingBlogs.js"));


const EsVenue = lazy(() => import("./pages/admin/defaultSetup/esVenue.js"));
const EsSubjectType = lazy(() => import("./pages/admin/defaultSetup/esSubjectType.js"));
const EsCountries = lazy(() => import("./pages/admin/defaultSetup/esCountries.js"));
const EsSubdomainType = lazy(() => import("./pages/admin/defaultSetup/esSubdomainType.js"));
const EsSeriesSetup = lazy(() => import("./pages/admin/defaultSetup/esSeriesSetup.js"));
const EsSeriesType = lazy(() => import("./pages/admin/defaultSetup/esSeriesType.js"));

const PaidAccommodation = lazy(() => import("./pages/admin/accommodationStatus/paidAccommodation.js"));
const FreeAccommodation = lazy(() => import("./pages/admin/accommodationStatus/freeAccommodation.js"));

const PendingFreeParticipantForm = lazy(() => import("./pages/admin/participantForm/pendingFreeParticipantForm.js"));
const ApprovedFreeParticipantForm = lazy(() => import("./pages/admin/participantForm/approvedFreeParticipantForm.js"));

const PendingOnsiteParticipantForm = lazy(() => import("./pages/admin/participantForm/pendingOnsiteParticipantForm.js"));
const ApprovedOnsiteParticipantForm = lazy(() => import("./pages/admin/participantForm/approvedOnsiteParticipantForm.js"));

const ConferenceEvent = lazy(() => import("./pages/admin/eventSetup/conferenceEvent.js"));
const WebinarEvent = lazy(() => import("./pages/admin/eventSetup/webinarEvent.js"));

const RefundApproved = lazy(() => import("./pages/admin/refundStatus/refundApproved.js"));
const RefundPending = lazy(() => import("./pages/admin/refundStatus/refundPending.js"));

const TransactionStatus = lazy(() => import("./pages/admin/transactionStatus/transactionStatus.js"));

const RevenueAll = lazy(() => import("./pages/admin/revenueStatus/revenueAll.js"));
const RevenueConference = lazy(() => import("./pages/admin/revenueStatus/revenueConference.js"));
const RevenueWebinar = lazy(() => import("./pages/admin/revenueStatus/revenueWebinar.js"));

const Abstract = lazy(() => import("./pages/admin/leadForms/abstract.js"));
const Brochure = lazy(() => import("./pages/admin/leadForms/brochure.js"));
const Contact = lazy(() => import("./pages/admin/leadForms/contact.js"));
const PastconfProceedingsLists = lazy(() => import("./pages/admin/leadForms/pastconfProceedingsLists.js"));

//revenue forms
const Registration = lazy(() => import("./pages/admin/revenueForms/registration.js"));
const SelfRegistration = lazy(() => import("./pages/admin/revenueForms/selfRegistration.js"));
const PaypalTransactions = lazy(() => import("./pages/admin/revenueForms/paypalTransactions.js"));
const RazorpayTransactions = lazy(() => import("./pages/admin/revenueForms/razorpayTransactions.js"));


const ProgramManager = lazy(() => import("./pages/event/abstractReceipt/programManager.js"));
const Abreviewers = lazy(() => import("./pages/event/abstractReceipt/abReviewers.js"));
const AbstractReceipt = lazy(() => import("./pages/event/abstractReceipt/abstractReceipt.js"));
const AbstractReceiptPdf = lazy(() => import("./pages/event/abstractReceipt/abstractReceiptPdf.jsx"));

//Invitation Letter
const InvitationLetter = lazy(() => import("./pages/event/invitationLetter/invitationLetter.js"));
const InvitationLetterPdf = lazy(() => import("./pages/event/invitationLetter/invitationLetterPdf.jsx"));

//blogs
const Blogs = lazy(() => import("./pages/event/blogs/blogs.js"));
//payment receipt form
// import PaymentReceipt from './pages/admin/paymentReceiptForm/paymentReceipt.js';
// import Pdf from './pages/pdfGeneration/pdf.js';

//event lead forms
const EmBrochure = lazy(() => import("./pages/event/emleadForms/embrochure.js"));
const EmAbstract = lazy(() => import("./pages/event/emleadForms/emabstract.js"));
const EmContact = lazy(() => import("./pages/event/emleadForms/emcontact.js"));
const EmPastconfProceedingsLists = lazy(() => import("./pages/event/emleadForms/empastconfProceedingsLists.js"));

//event revenue forms
const EmRegistration = lazy(() => import("./pages/event/emrevenueForms/emregistration.js"));
const EmSelfRegistration = lazy(() => import("./pages/event/emrevenueForms/emselfRegistration.js"));

const PaymentReceipt = lazy(() => import("./pages/event/paymentReceiptForm/paymentReceipt.js"));
const FreeParticipantForm = lazy(() => import("./pages/event/participantForm/freeParticipantForm.js"));
const OnsiteParticipantForm = lazy(() => import("./pages/event/participantForm/onsiteParticipantForm.js"));

const InvoiceReceipt = lazy(() => import("./pages/event/invoiceReceiptForm/invoiceReceipt.js"));
const Refund = lazy(() => import("./pages/event/refundForms/refund.js"));

const Accommodation = lazy(() => import("./pages/event/accommodationForm/accommodation.js"));

const Dashboard = lazy(() => import("./pages/event/dashboard/charts/dashboard.js"));
const CmsUser = lazy(() => import("./pages/admin/cmsUserCreationForms/cmsUser.js"));
const MetaTags = lazy(() => import("./pages/admin/seoConfig/metaTags.js"));
const SeoContextPage = lazy(() => import("./pages/admin/seoConfig/seoContextPage.js"));

const EventIntroductionSpeech = lazy(() => import("./pages/event/onsite/EventIntroductionSpeech.jsx"));
const EventModeratorSpeech = lazy(() => import("./pages/event/onsite/EventModeratorSpeech.jsx"));




const Revenue = lazy(() => import("./pages/finance/revenueStatus/revenue.js"));

//management dashboard
const MgmtDashboard = lazy(() => import("./pages/management/dashboard/mgmtDashboard.jsx"));

const MgmtPrCurrencyType = lazy(() => import("./pages/management/paymentReceipt/mgmtPrCurrencyType.js"));
const MgmtPrEventType = lazy(() => import("./pages/management/paymentReceipt/mgmtPrEventType.js"));
const MgmtPrOccupancyType = lazy(() => import("./pages/management/paymentReceipt/mgmtPrOccupancyType.js"));
const MgmtPrRegistrationType = lazy(() => import("./pages/management/paymentReceipt/mgmtPrRegistrationType.js"));
const MgmtPrPaymentType = lazy(() => import("./pages/management/paymentReceipt/mgmtPrPaymentType.js"));
const MgmtPrRegistrationCategory = lazy(() => import("./pages/management/paymentReceipt/mgmtPrRegistrationCategory.js"));
const MgmtPaymentReceiptReceived = lazy(() => import("./pages/management/paymentReceipt/mgmtPaymentReceiptReceived.js"));
const MgmtPaymentReceiptGenerated = lazy(() => import("./pages/management/paymentReceipt/mgmtPaymentReceiptGenerated.js"));
const MgmtPaymentReceiptPdf = lazy(() => import("./pages/management/paymentReceipt/mgmtPaymentReceiptPdf.jsx"));

const MgmtInvoiceReceiptReceived = lazy(() => import("./pages/management/invoiceReceipt/mgmtInvoiceReceiptReceived.js"));
const MgmtInvoiceReceiptGenerated = lazy(() => import("./pages/management/invoiceReceipt/mgmtInvoiceReceiptGenerated.js"));
const MgmtInvoiceRegType = lazy(() => import("./pages/management/invoiceReceipt/mgmtInvoiceRegType.js"));
const MgmtInvoiceInBank = lazy(() => import("./pages/management/invoiceReceipt/mgmtInvoiceInBank.js"));
const MgmtInvoiceUsBank = lazy(() => import("./pages/management/invoiceReceipt/mgmtInvoiceUsBank.js"));
const MgmtInvoiceReceiptPdf = lazy(() => import("./pages/management/invoiceReceipt/mgmtInvoiceReceiptPdf.jsx"));

const MgmtRevenueAll = lazy(() => import("./pages/management/revenueStatus/mgmtRevenueAll.js"));
const MgmtRevenueConference = lazy(() => import("./pages/management/revenueStatus/mgmtRevenueConference.js"));
const MgmtRevenueWebinar = lazy(() => import("./pages/management/revenueStatus/mgmtRevenueWebinar.js"));

const MgmtPaidAccommodation = lazy(() => import("./pages/management/accommodationStatus/mgmtPaidAccommodation.js"));
const MgmtFreeAccommodation = lazy(() => import("./pages/management/accommodationStatus/mgmtFreeAccommodation.js"));

const MgmtRefundApproved = lazy(() => import("./pages/management/refundStatus/mgmtRefundApproved.js"));
const MgmtRefundPending = lazy(() => import("./pages/management/refundStatus/mgmtRefundPending.js"));

const MgmtTransactionStatus = lazy(() => import("./pages/management/transactionStatus/mgmtTransactionStatus.js"));
const MgmtPaypalTransactions = lazy(() => import("./pages/management/paypalTransactions/mgmtpaypalTransactions.js"));

// conference management
const AccommodationSetup = lazy(() => import("./pages/management/accommodationSetup/accommodationSetup.js"));
const MgmtWaitingAccommodation = lazy(() => import("./pages/management/accommodation/mgmtWaitingAccommodation.js"));
const MgmtPendingAccommodation = lazy(() => import("./pages/management/accommodation/mgmtPendingAccommodation.js"));
const MgmtVerifiedAccommodation = lazy(() => import("./pages/management/accommodation/mgmtVerifiedAccommodation.js"));
const MgmtStagingAccommodation = lazy(() => import("./pages/management/accommodation/mgmtStagingAccommodation.js"));
const MgmtCancelledAccommodation = lazy(() => import("./pages/management/accommodation/mgmtCancelledAccommodation.js"));
const MgmtDeletedAccommodation = lazy(() => import("./pages/management/accommodation/mgmtDeletedAccommodation.js"));

// onsite management
const HotelSetup = lazy(() => import("./pages/admin/defaultSetup/HotelSetup.jsx"));
const HotelSetupList = lazy(() => import("./pages/admin/defaultSetup/HotelSetupList.jsx"));
const IntroductionSpeechView = lazy(() => import("./pages/event/onsite/IntroductionSpeechView.jsx"));
const ModeratorSpeechView = lazy(() => import("./pages/event/onsite/ModeratorSpeechView.jsx"));
const ParticipantSetupForm = lazy(() => import("./pages/event/onsite/participants/ParticipantSetupForm.jsx"));
const PresentationSetupForm = lazy(() => import("./pages/event/onsite/presentations/PresentationSetupForm.jsx"));
const ParticipantSetupList = lazy(() => import("./pages/event/onsite/participants/ParticipantSetupList.jsx"));
const PresentationSetupList = lazy(() => import("./pages/event/onsite/presentations/PresentationSetupList.jsx"));
// jo
// sponsorship registration management
const RegistrationSponsorship = lazy(() => import("./pages/event/registrationSponsorship/registrationsponsorship.js"));
const RegistrationSponsorshipInquiryList = lazy(() => import("./pages/event/registrationSponsorship/regsponsorshipinquiryList.js"));
const RegistrationSponsorshipTransactionList = lazy(() => import("./pages/event/registrationSponsorship/registrationsponsorshiptransactionlist.js"));
const RegistrationSponsorshipList = lazy(() => import("./pages/event/registrationSponsorship/registrationsponsorshipList.js"));

const NotFound = lazy(() => import("./pages/NotFound.jsx"));

const AppRoutes = () => (
  <Router>
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />

      <Route element={<ProtectedRoute roles={["admin"]} />}>
        <Route element={<AppLayout />}>
          <Route path="/adminDashboard" element={<AdminDashboard />} />
          <Route path="/prCurrencyType" element={<PrCurrencyType />} />
          <Route path="/prEventType" element={<PrEventType />} />
          <Route path="/prOccupancyType" element={<PrOccupancyType />} />
          <Route path="/prRegistrationType" element={<PrRegistrationType />} />
          <Route path="/prPaymentType" element={<PrPaymentType />} />
          <Route path="/prParticipantPaymentType" element={<PrParticipantPaymentType />} />
          <Route path="/prRegistrationCategory" element={<PrRegistrationCategory />} />
          <Route path="/paymentReceiptReceived" element={<PaymentReceiptReceived />} />
          <Route path="/paymentReceiptGenerated" element={<PaymentReceiptGenerated />} />
          <Route path="/invoiceReceiptReceived" element={<InvoiceReceiptReceived />} />
          <Route path="/invoiceReceiptGenerated" element={<InvoiceReceiptGenerated />} />
          <Route path="/invoiceRegType" element={<InvoiceRegType />} />
          <Route path="/invoiceInBank" element={<InvoiceInBank />} />
          <Route path="/invoiceUsBank" element={<InvoiceUsBank />} />
          <Route path="/pendingProgramManager" element={<PendingProgramManager />} />
          <Route path="/approvedProgramManager" element={<ApprovedProgramManager />} />
          <Route path="/allreviewers" element={<AllReviewers />} />
          <Route path="/approvedreviewers" element={<ApprovedReviewers />} />
          <Route path="/pendingreviewers" element={<PendingReviewers />} />
          <Route path="/approvedblogs" element={<ApprovedBlogs />} />
          <Route path="/pendingblogs" element={<PendingBlogs />} />
          <Route path="/invitationCategory" element={<InvitationCategory />} />
          <Route path="/allInvitationLetter" element={<AllInvitationLetter />} />
          <Route path="/currentInvitationLetter" element={<CurrentInvitationLetter />} />
          <Route path="/abCategory" element={<AbCategory />} />
          <Route path="/abstractType" element={<AbstractType />} />
          <Route path="/esVenue" element={<EsVenue />} />
          <Route path="/esSubjectType" element={<EsSubjectType />} />
          <Route path="/esCountries" element={<EsCountries />} />
          <Route path="/esSubdomainType" element={<EsSubdomainType />} />
          <Route path="/esSeriesType" element={<EsSeriesType />} />
          <Route path="/esSeriesSetup" element={<EsSeriesSetup />} />
          <Route path="/hotelSetup" element={<HotelSetup />} />
          <Route path="/hotelSetupList" element={<HotelSetupList />} />
          <Route path="/paidAccommodation" element={<PaidAccommodation />} />
          <Route path="/freeAccommodation" element={<FreeAccommodation />} />
          <Route path="/pendingFreeParticipantForm" element={<PendingFreeParticipantForm />} />
          <Route path="/approvedFreeParticipantForm" element={<ApprovedFreeParticipantForm />} />
          <Route path="/pendingOnsiteParticipantForm" element={<PendingOnsiteParticipantForm />} />
          <Route path="/approvedOnsiteParticipantForm" element={<ApprovedOnsiteParticipantForm />} />
          <Route path="/refundApproved" element={<RefundApproved />} />
          <Route path="/refundPending" element={<RefundPending />} />
          <Route path="/conferenceEvent" element={<ConferenceEvent />} />
          <Route path="/webinarEvent" element={<WebinarEvent />} />
          <Route path="/transactionStatus" element={<TransactionStatus />} />
          <Route path="/revenueAll" element={<RevenueAll />} />
          <Route path="/revenueConference" element={<RevenueConference />} />
          <Route path="/revenueWebinar" element={<RevenueWebinar />} />
          <Route path="/abstract" element={<Abstract />} />
          <Route path="/brochure" element={<Brochure />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/pastconfProceedingsLists" element={<PastconfProceedingsLists />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/selfRegistration" element={<SelfRegistration />} />
          <Route path="/paypalTransactions" element={<PaypalTransactions />} />
          <Route path="/razorpayTransactions" element={<RazorpayTransactions />} />
          <Route path="/cmsUser" element={<CmsUser />} />
          <Route path="/metaTags" element={<MetaTags />} />
          <Route path="/seoContextPage" element={<SeoContextPage />} />
        </Route>
        {/* Print / PDF views render without the portal shell */}
        <Route path="/paymentReceiptPdf" element={<PaymentReceiptPdf />} />
        <Route path="/invoiceReceiptPdf" element={<InvoiceReceiptPdf />} />
      </Route>

      <Route element={<ProtectedRoute roles={["event"]} />}>
        <Route element={<AppLayout />}>
          <Route path="/programManager" element={<ProgramManager />} />
          <Route path="/abreviewers" element={<Abreviewers />} />
          <Route path="/abstractReceipt" element={<AbstractReceipt />} />
          <Route path="/embrochure" element={<EmBrochure />} />
          <Route path="/emabstract" element={<EmAbstract />} />
          <Route path="/emcontact" element={<EmContact />} />
          <Route path="/empastconfProceedingsLists" element={<EmPastconfProceedingsLists />} />
          <Route path="/emregistration" element={<EmRegistration />} />
          <Route path="/emselfRegistration" element={<EmSelfRegistration />} />
          <Route path="/paymentReceipt" element={<PaymentReceipt />} />
          <Route path="/freeParticipantForm" element={<FreeParticipantForm />} />
          <Route path="/onsiteParticipantForm" element={<OnsiteParticipantForm />} />
          <Route path="/invoiceReceipt" element={<InvoiceReceipt />} />
          <Route path="/refund" element={<Refund />} />
          <Route path="/invitationLetter" element={<InvitationLetter />} />
          <Route path="/accommodation" element={<Accommodation />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/eventIntroductionSpeech" element={<EventIntroductionSpeech />} />
          <Route path="/eventModeratorSpeech" element={<EventModeratorSpeech />} />
          <Route path="/participantSetupList" element={<ParticipantSetupList />} />
          <Route path="/participantSetup/create" element={<ParticipantSetupForm />} />
          <Route path="/participantSetup/:id" element={<ParticipantSetupForm />} />
          <Route path="/presentationSetupList" element={<PresentationSetupList />} />
          <Route path="/presentationSetup/create" element={<PresentationSetupForm />} />
          <Route path="/presentationSetup/:id" element={<PresentationSetupForm />} />
          <Route path="/emRegistrationSponsorshipList" element={<RegistrationSponsorshipList />} />
          <Route path="/emRegistrationSponsorship" element={<RegistrationSponsorship />} />
          <Route path="/emRegistrationSponsorship/:id" element={<RegistrationSponsorship />} />
          <Route path="/emRegistrationSponsorshipTransaction" element={<RegistrationSponsorshipTransactionList />} />
          <Route path="/emSponsorshipInquiryList" element={<RegistrationSponsorshipInquiryList />} />
        </Route>
        {/* Print / PDF views render without the portal shell */}
        <Route path="/abstractReceiptPdf" element={<AbstractReceiptPdf />} />
        <Route path="/invitationLetterPdf" element={<InvitationLetterPdf />} />
        <Route path="/introductionspeech-view" element={<IntroductionSpeechView />} />
        <Route path="/moderatorspeech-view" element={<ModeratorSpeechView />} />
      </Route>

      <Route element={<ProtectedRoute roles={["finance"]} />}>
        <Route element={<AppLayout />}>
          <Route path="/revenue" element={<Revenue />} />
        </Route>
      </Route>

      <Route element={<ProtectedRoute roles={["management"]} />}>
        <Route element={<AppLayout />}>
          <Route path="/mgmtDashboard" element={<MgmtDashboard />} />
          <Route path="/mgmtPrCurrencyType" element={<MgmtPrCurrencyType />} />
          <Route path="/mgmtPrEventType" element={<MgmtPrEventType />} />
          <Route path="/mgmtPrOccupancyType" element={<MgmtPrOccupancyType />} />
          <Route path="/mgmtPrRegistrationType" element={<MgmtPrRegistrationType />} />
          <Route path="/mgmtPrPaymentType" element={<MgmtPrPaymentType />} />
          <Route path="/mgmtPrRegistrationCategory" element={<MgmtPrRegistrationCategory />} />
          <Route path="/mgmtPaymentReceiptReceived" element={<MgmtPaymentReceiptReceived />} />
          <Route path="/mgmtPaymentReceiptGenerated" element={<MgmtPaymentReceiptGenerated />} />
          <Route path="/mgmtInvoiceReceiptReceived" element={<MgmtInvoiceReceiptReceived />} />
          <Route path="/mgmtInvoiceReceiptGenerated" element={<MgmtInvoiceReceiptGenerated />} />
          <Route path="/mgmtInvoiceRegType" element={<MgmtInvoiceRegType />} />
          <Route path="/mgmtInvoiceInBank" element={<MgmtInvoiceInBank />} />
          <Route path="/mgmtInvoiceUsBank" element={<MgmtInvoiceUsBank />} />
          <Route path="/mgmtPaidAccommodation" element={<MgmtPaidAccommodation />} />
          <Route path="/mgmtFreeAccommodation" element={<MgmtFreeAccommodation />} />
          <Route path="/mgmtRefundApproved" element={<MgmtRefundApproved />} />
          <Route path="/mgmtRefundPending" element={<MgmtRefundPending />} />
          <Route path="/mgmtTransactionStatus" element={<MgmtTransactionStatus />} />
          <Route path="/MgmtPaypalTransactions" element={<MgmtPaypalTransactions />} />
          <Route path="/mgmtRevenueAll" element={<MgmtRevenueAll />} />
          <Route path="/mgmtRevenueConference" element={<MgmtRevenueConference />} />
          <Route path="/mgmtRevenueWebinar" element={<MgmtRevenueWebinar />} />
          <Route path="/accommodationSetup" element={<AccommodationSetup />} />
          <Route path="/mgmtWaitingAccommodation" element={<MgmtWaitingAccommodation />} />
          <Route path="/mgmtPendingAccommodation" element={<MgmtPendingAccommodation />} />
          <Route path="/mgmtVerifiedAccommodation" element={<MgmtVerifiedAccommodation />} />
          <Route path="/mgmtStagingAccommodation" element={<MgmtStagingAccommodation />} />
          <Route path="/mgmtCancelledAccommodation" element={<MgmtCancelledAccommodation />} />
          <Route path="/mgmtDeletedAccommodation" element={<MgmtDeletedAccommodation />} />
        </Route>
        {/* Print / PDF views render without the portal shell */}
        <Route path="/mgmtPaymentReceiptPdf" element={<MgmtPaymentReceiptPdf />} />
        <Route path="/mgmtInvoiceReceiptPdf" element={<MgmtInvoiceReceiptPdf />} />
      </Route>

      <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  </Router>
);

export default AppRoutes;
